<template>
  <Flex direction="column">
    <BaseStatusIcon :state="state" />
    <Flex
      direction="column"
      align="center"
      :gap="0.5"
    >
      <BaseHeading>{{ heading }}</BaseHeading>
      <BaseText>{{ description }}</BaseText>
    </Flex>
    <BaseProgressBar
      v-if="state === 'loading'"
      :percentage="progress"
      v-test="'wavy-onboarding-progress'"
    />
    <BaseAlert
      v-if="state === 'loading'"
      :text="t('wavy_onboarding.copy_wavy_data.processing.loading.alert')"
      color="warning"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';

const props = defineProps<{
  state: 'success' | 'error' | 'loading';
  progress: number;
}>();

const { t } = useI18n();

const heading = computed(() => {
  switch (props.state) {
    case 'loading':
      return t('wavy_onboarding.copy_wavy_data.processing.loading.heading');
    case 'success':
      return t('wavy_onboarding.copy_wavy_data.processing.success.heading');
    case 'error':
      return t('wavy_onboarding.copy_wavy_data.processing.error.heading');
  }
});

const description = computed(() => {
  switch (props.state) {
    case 'loading':
      return t('wavy_onboarding.copy_wavy_data.processing.loading.description');
    case 'success':
      return t(
        'wavy_onboarding.copy_wavy_data.processing.success.description',
        brandName(),
      );
    case 'error':
      return t('wavy_onboarding.copy_wavy_data.processing.error.description');
  }
});
</script>
